/**
* author: duxin
* date: 2020/4/7
* describe: 关于我们块
*/

<template>
  <div class="chunk-wrap">
    <!-- <p class="p1">{{$t("home.about")}}</p> -->
    <!-- <p class="p2 p1">{{$t("home.content1")}}</p> -->
    <p class="p1">{{$t("home.content11")}}</p>
    <!-- <p class="p2">{{$t("home.content12")}}</p> -->
    <div class="content-wrap-1">
      <img class="about-img" src="../../../assets/home-content.jpg">
      <div class="right-1">
        <p>{{$t("home.content2")}}
          <br />
          {{$t("home.content3")}}
        </p>
        <div class="more-btn-icon">
          <RouterLink to="/about/company">
            <ElButton type="primary" class="more-btn">{{$t("home.seeMore")}}</ElButton>
            <i class="iconfont iconmore"></i>
          </RouterLink>
        </div>
      </div>
    </div>
    <div class="content-wrap-2">
      <div class="cell">
        <p :class="lang == 'en' ? 'title' : 'title-60'">{{$t("home.values")}}</p>
        <br />
        <p> {{$t("home.valuesText")}}</p>
      </div>
      <div class="cell">
        <p :class="lang == 'en' ? 'title' : 'title-60'">{{$t("home.mission")}}</p>
        <br />
        <p>{{$t("home.missionText")}}</p>
      </div>
      <div class="cell">
        <p :class="lang == 'en' ? 'title' : 'title-60'">{{$t("home.vision")}}</p>
        <br />
        <p class="p">{{$t("home.visionText")}} </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about-me-chunk",
  computed: {
      lang() {
          return sessionStorage.getItem("language")
      }
  },
}
</script>

<style lang="less" scoped>
@import "../../../style/constant";
@import "./chunk";

.chunk-wrap {
  display: flex;
  flex-direction: column;
  align-self: center;
  .p1,
  .p2 {
    color: #5f5f5f;
  }
  .p1 {
    margin-top: 100px;
  }
  .p2 {
    font-size: 24px;
    margin-bottom: 24px;
    font-weight: 500;
  }
  .content-wrap-1 {
    display: flex;
    margin: 60px 0 50px;

    .about-img {
      width: 470px;
      max-height: 280px;
      flex-shrink: 0;
    }

    .right-1 {
      margin-left: 100px;
      color: @content-color;
      font-size: 16px;
      line-height: 30px;
      letter-spacing: 1px;

      .more-btn-icon {
        margin-top: 25px;
        position: relative;

        .more-btn {
          background-color: @primary-color;
          border-color: @primary-color;
        }

        .iconfont {
          position: absolute;
          width: 35px;
          height: 40px;
          left: 96px;
          line-height: 40px;
          color: #fff;
          text-align: center;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          background-color: @active-color;
          border-color: @active-color;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .content-wrap-2 {
    display: flex;
    margin-top: 80px;

    .cell {
      // display: flex;
      // align-items: center;
      // flex-direction: column;
      // justify-content: center;
      flex: 1;
      height: 200px;
      text-align: center;
      color: white;

      .title {
        font-size: 24px;
        margin-top: 30px;
      }
      .title-60 {
        font-size: 24px;
        margin-top: 60px;
      }

      &:nth-child(1) {
        background-color: @primary-color;
      }

      &:nth-child(2) {
        background-color: #4f6dcd;
      }

      &:nth-child(3) {
        background-color: @active-color;
      }
      .p {
        padding: 0 10px;
      }
    }
  }
}
@media screen and (min-width: 320px) and (max-width: 480px) {
  .chunk-wrap {
    .p1{
      font-size: 21px;
      word-break: break-word;
    }
  }
  .content-wrap-1 {
    margin-top: 30px;
    flex-direction: column;
    .about-img {
      width: 100%;
    }
    .right-1 {
      margin-top: 30px;
      margin-left: 0 !important;
    }
  }
  .content-wrap-2 {
    flex-direction: column;
    height: calc(3 * 260px);
    margin-top: 40px;
    div {
      height: 260px;
    }
  }
}
</style>